// File: src/components/AnalysisPanel/PromptMessageCard.tsx

import React, { useState, useRef, useEffect } from "react";
import styles from "./PromptMessageCard.module.css";

interface PromptMessage {
    role: string;
    content: string;
}

interface Props {
    message: PromptMessage;
}

export const PromptMessageCard: React.FC<Props> = ({ message }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (contentRef.current) {
            // Check if content exceeds 5 lines
            const lineHeight = parseInt(window.getComputedStyle(contentRef.current).lineHeight);
            const maxHeight = lineHeight * 5;
            setIsOverflowing(contentRef.current.scrollHeight > maxHeight);
        }
    }, [message.content]);

    return (
        <div className={`${styles.card} ${styles[message.role]}`}>
            <div className={styles.header}>
                <strong>{message.role.toUpperCase()}</strong>
                {isOverflowing && (
                    <button className={styles.expandButton} onClick={() => setIsExpanded(!isExpanded)}>
                        {isExpanded ? "Show less" : "Show more"}
                    </button>
                )}
            </div>
            <div ref={contentRef} className={`${styles.content} ${!isExpanded && isOverflowing ? styles.collapsed : ""}`}>
                {message.content}
            </div>
        </div>
    );
};
